import {Root} from '@radix-ui/react-select';

export const Select = Root;

export * from './SelectContent';
export * from './SelectItem';
export * from './SelectItemIcon';
export * from './SelectLabel';
export * from './SelectTrigger';
